import type { FC } from 'react';
import { Layout, StyledHeader } from '@/components/layout';
import { Col, Row } from 'antd';
import { ContentContainer, FlexContainer } from './components/Containers';
import { Hero } from './components/Hero';
import { ThemeSwitcher } from '@enmon-monorepo/ui';
import { AuthRouter } from './containers/Router';
import { LanguageMenu } from '@/components/LanguageMenu';
import { IS_THEME_SWITCHER_ENABLED } from '@/containers/ant-config-provider/AppAntConfigProvider';

export const AuthPage: FC = () => (
  <Layout style={{ height: '100%' }}>
    <StyledHeader>
      <Row align="middle" justify="end" wrap={false}>
        <Col>
          <LanguageMenu />
        </Col>

        {IS_THEME_SWITCHER_ENABLED && (
          <Col>
            <ThemeSwitcher />
          </Col>
        )}
      </Row>
    </StyledHeader>
    <Row style={{ height: '100%' }}>
      <FlexContainer>
        <ContentContainer>
          <AuthRouter />
        </ContentContainer>
      </FlexContainer>
      <Hero />
    </Row>
  </Layout>
);
